import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth';
import { Layout } from './components/Layout';
import { Loading } from './components/ui';
import { BenutzerPage } from './pages/Benutzer';
import { EinsaetzePage } from './pages/Einsaetze';
import { EinsatzDetailPage } from './pages/EinsatzDetail';
import { BargeldPage, ForderungDetailPage, ForderungenPage } from './pages/Forderungen';
import { LieferungDetailPage, LieferungNeuPage } from './pages/Lieferung';
import { BestellungDetailPage } from './pages/BestellungDetail';
import { BestellungNeuPage } from './pages/BestellungNeu';
import { EskalationPage } from './pages/Eskalation';
import { FristenPage } from './pages/Fristen';
import { KachelPage } from './pages/Kachel';
import { KundeAktePage } from './pages/KundeAkte';
import { KundenPage } from './pages/Kunden';
import { LoginPage } from './pages/Login';
import { MeinTagPage } from './pages/MeinTag';
import { PasswortPage } from './pages/Passwort';
import { ServiceBelegPage } from './pages/ServiceBeleg';
import { ServiceDetailPage } from './pages/ServiceDetail';
import { ServiceNeuPage } from './pages/ServiceNeu';
import { VorgangListePage } from './pages/VorgangListe';
import { TicketDetailPage } from './pages/TicketDetail';
import { TicketsPage } from './pages/Tickets';

export function App() {
  const { user, ready, can } = useAuth();

  if (!ready) return <Loading />;
  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route element={<Layout />}>
        <Route path="/" element={<MeinTagPage />} />
        <Route path="/bereich/:art" element={<KachelPage />} />
        <Route path="/tickets" element={<TicketsPage />} />
        <Route path="/tickets/:id" element={<TicketDetailPage />} />
        <Route path="/kunden" element={<KundenPage />} />
        <Route path="/kunden/:id" element={<KundeAktePage />} />
        <Route path="/passwort" element={<PasswortPage />} />
        <Route path="/einsaetze" element={<EinsaetzePage />} />
        <Route path="/einsaetze/:id" element={<EinsatzDetailPage />} />
        {can('admin', 'verkauf', 'fahrer') && (
          <>
            <Route path="/lieferungen" element={<VorgangListePage key="lieferung" liste="lieferung" />} />
            <Route path="/lieferungen/neu" element={<LieferungNeuPage />} />
            <Route path="/lieferungen/:id" element={<LieferungDetailPage />} />
          </>
        )}
        {can('admin', 'verkauf') && (
          <>
            <Route path="/forderungen" element={<ForderungenPage />} />
            <Route path="/forderungen/:id" element={<ForderungDetailPage />} />
            <Route path="/kasse/bargeld" element={<BargeldPage />} />
          </>
        )}
        {can('admin', 'verkauf', 'techniker') && (
          <>
            <Route path="/bestellungen" element={<VorgangListePage key="bestellung" liste="bestellung" />} />
            <Route path="/bestellungen/neu" element={<BestellungNeuPage />} />
            <Route path="/bestellungen/:id" element={<BestellungDetailPage />} />
            <Route path="/service" element={<VorgangListePage key="werkstatt" liste="werkstatt" />} />
            <Route path="/service/aussendienst" element={<VorgangListePage key="aussendienst" liste="aussendienst" />} />
            <Route path="/service/neu" element={<ServiceNeuPage />} />
            <Route path="/service/:id" element={<ServiceDetailPage />} />
            <Route path="/service/:id/beleg" element={<ServiceBelegPage />} />
          </>
        )}
        {can('admin') && (
          <>
            <Route path="/einstellungen/fristen" element={<FristenPage />} />
            <Route path="/einstellungen/eskalation" element={<EskalationPage />} />
            <Route path="/einstellungen/benutzer" element={<BenutzerPage />} />
          </>
        )}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
